import { Box, Container, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import PageHeader from 'components/page-header/PageHeader';
import PageTitleMobile from 'components/page-header/PageTitleMobile';
import { withIronSessionSsr } from 'iron-session/next';
import RootLayout from 'layouts/RootLayout';
import { sessionOptions } from 'libs/iron-session';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { NextPageWithLayout } from './_app';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

const ShippingServiceChargePage: NextPageWithLayout = () => {
  const { t } = useTranslation(['common', 'returns-refunds']);

  return (
    <>
      <Head>
        <title>{t('returns-refunds:returns-refunds:title')} | แลมป์ตั้น</title>
      </Head>
      <Box>
        <PageHeader
          title={t('returns-refunds:returns-refunds:title')}
        ></PageHeader>
        <PageTitleMobile>
          {t('returns-refunds:returns-refunds:title')}
        </PageTitleMobile>
        <Container
          pt={{
            base: 8,
            md: 12,
          }}
          pb={{
            base: 8,
            md: 20,
          }}
        >
          <Heading fontWeight="500" mb={6} fontSize="lg">
            {t('returns-refunds:returns-refunds:online_heading')}
          </Heading>
          <Heading fontWeight="500" mb={6} fontSize="lg">
            {t('returns-refunds:returns-refunds:steps_heading')}
          </Heading>
          <ul
            style={{
              marginLeft: '20px',
            }}
          >
            {Array.from({ length: 7 }).map((_, index) => (
              <li
                key={index}
                style={{
                  marginBottom: '4px',
                }}
              >
                {t(`returns-refunds:returns-refunds:step${index + 1}`)}
              </li>
            ))}
          </ul>
        </Container>
      </Box>
    </>
  );
};

ShippingServiceChargePage.getLayout = (page) => {
  return <RootLayout>{page}</RootLayout>;
};

export const getServerSideProps = withIronSessionSsr(async function ({
  req,
  res,
  locale,
}) {
  const _locale = locale || 'th';

  return {
    props: {
      ...(await serverSideTranslations(_locale, ['common', 'returns-refunds'])),
    },
  };
},
sessionOptions);

export default ShippingServiceChargePage;
